export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--9-2!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/sass-loader/lib/loader.js??ref--9-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PasswordReset.vue?vue&type=style&index=0&id=27d06c28&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/resetpass/PasswordReset.vue?vue&type=style&index=0&id=27d06c28&prod&lang=scss
// module id = LZhv
// module chunks = 41